import { Address } from './Address';
export enum FormType {
  TwoWheeler = 'TwoWheelerForm',
  Trucks = 'TrucksForm',
  Partload = 'PartloadForm',
}

export type FareEstimateForm = {
  pickupAddress: Address;
  dropAddress: Address;
  name: string;
  mobile: string;
  requirement: string;
  serviceCategory: string;
  geoRegionId?: string | null;
};

type Form<T extends FormType> = { type: T; data: FareEstimateForm };

export type FareEstimateFormType =
  | Form<FormType.TwoWheeler>
  | Form<FormType.Trucks>
  | Form<FormType.Partload>;
